// extracted by mini-css-extract-plugin
module.exports = {"search_wrapper":"searchbar-container_search_wrapper__dsfcK"};